module.exports = __webpack_public_path__ + "img/BO.a0c61963.svg";